module.exports = __webpack_public_path__ + "static/img/valores.e3b830c3.jpg";